import axios from "axios";
import {
    SET_SUMMARY_REQUEST,
    SET_SUMMARY_SUCCESS,
    SET_SUMMARY_ERROR,
} from "./../../constants/kpiSummaryDashboardEnhancement/kpiSummaryLevelOneConstants";

export const fetchSummaryDataCountForExecution = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_SUMMARY_REQUEST });
        axios({
            url: `/get/base_scenario/variation/count/execution?cad_topology_job_uuid=${payload}`,
            method: "GET",
        })
            .then((response) => {
                if (response && response.status === 200) {
                    if (response.data.result.length !== 0) {
                        dispatch({
                            type: SET_SUMMARY_SUCCESS,
                            successSummaryData: response.data.result[0],
                        });
                    } else {
                        dispatch({
                            type: SET_SUMMARY_SUCCESS,
                            successSummaryData: response.data,
                        });
                    }
                } else {
                    dispatch({
                        type: SET_SUMMARY_ERROR,
                        payload: "Error occurred while fetching this request",
                    });
                }
            })
            .catch((error) => {
                // dispatch({ type: SET_SUMMARY_ERROR, payload: error.response.data.message });
                // if(error.hasOwnProperty("response") && error.response.hasOwnProperty("data")
                //     && error.response.data.hasOwnProperty("message")){
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({ type: SET_SUMMARY_ERROR, payload: error.response.data.message });
                } else {
                    dispatch({
                        type: SET_SUMMARY_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log("error msg", error);
        const errorMsg = error.message || "Error occurred while fetching this request!";
        dispatch({ type: SET_SUMMARY_ERROR, payload: errorMsg });
    }
};
